<template>
  <div class="video-list-cont">
    <div class="nav-tabs">
      <div
        v-for="(item, index) in rangeList"
        :key="index"
        @click="changeTab(item.parameter)"
        class="tab-item"
        :class="{'bg-cur':pageData.parameter == item.parameter}"
      >{{ item.title }}</div>
    </div>
    <div class="video-scroll-box">
      <EmptyTip v-if="pageData.list.length == 0 && loadFinish" emptyTip="亲爱的小朋友，暂时还没有的视频哦" />
      <template v-else>
        <ScrollBox :list="pageData.list" @getData="getData">
          <div class="video-list-cont__box">
            <div
              v-for="(item, index) in pageData.list"
              @click="viewVideo(item)"
              :key="index"
              class="item"
            >
              <div class="img-box">
                <img :src="item.video_coverimg" alt />
              </div>
              <p>{{ item.video_title }}</p>
            </div>
          </div>
        </ScrollBox>
      </template>
    </div>

    <div class="video-pop-mask" v-if="showBookBox && videoDetail">
      <div class="video-pop-box">
        <span class="video-pop-close" @click="showBookBox = false"></span>
        <div class="book-box-lf">
          <p class="title">{{ videoDetail.video_title }}</p>
          <img class="img-poster" :src="videoDetail.video_coverimg" alt />
        </div>
        <div class="book-box-rt">
          <p class="desc">{{ videoDetail.video_remark }}</p>
          <p class="limit-time">{{ videoDetail.readbooks_stoptime }}</p>
          <div class="pop-box-btns" style="margin-top:80px;">
            <button type="button" @click="viewDetail(videoDetail)" class="read-btn bg-base">{{$t('blendType.nowPlay')}}</button>
            <button
              type="button"
              @click="changeLike(videoDetail.video_id)"
              class="love-btn bg-base"
            >
              <em class="love-icon"></em>
              <template v-if="isLove">{{$t('blendType.cancleLove')}}</template>
              <template v-else>{{$t('blendType.love')}}</template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ScrollBox from "@/components/ScrollBox";
import VideoHttp from "../video";
import EmptyTip from "@/components/Empty";

export default {
  name: "video-home",
  data() {
    return {
      canLoad: true,
      isLoading: false,
      loadFinish: false,

      showBookBox: false,
      videoDetail: null,
      isLove: false,

      rangeList: [],
      pageData: {
        parameter: "",
        p: 1,
        num: 30,
        list: []
      }
    };
  },
  components: {
    ScrollBox,
    EmptyTip
  },
  created() {
    this.$emit("changeFromTitle", '');
    this.$emit("changeFromType", "main");
    this.$store.dispatch('setLoadingStatus', true)
    this.student_id = this.$store.state.currentChild.student_id;
    this.getVideoType();
    this.getVideo();
  },
  methods: {
    // 视听资源->视频分类获取
    getVideoType() {
      VideoHttp.getVideoType({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id
      }).then(res => {
        if (res.data.error == 0) {
          this.rangeList = res.data.result;
        } else {
          this.rangeList = [];
        }
      });
    },
    // 视听资源->视频资源获取
    getVideo() {
      if (this.canLoad) {
        this.isLoading = true;
        this.$store.dispatch('setLoadingStatus', true)
        VideoHttp.getVideo({
          member_id: this.$store.state.member_id,
          token: this.$store.state.token,
          student_id: this.student_id,
          parameter: this.pageData.parameter,
          p: this.pageData.p,
          num: this.pageData.num
        }).then(res => {
          const { error, result } = res.data;
          if (error == 0) {
            if (result.list.length < this.pageData.p) {
              this.canLoad = false;
            }
            this.pageData.list = this.pageData.list.concat(result.list);
          } else {
            this.canLoad = false;
            this.pageData.list = this.pageData.list.concat([]);
          }
          ++this.pageData.p;
          this.isLoading = false;
          this.loadFinish = true;
          this.$store.dispatch('setLoadingStatus', false)
        });
      }
    },
    changeTab(v) {
      this.loadFinish = false;
      this.pageData.parameter = v;
      this.canLoad = true;
      this.isLoading = false;
      this.pageData.p = 1;
      this.pageData.list = [];
      this.getVideo();
    },
    getData() {
      console.log("getData");
      if (!this.isLoading && this.canLoad) {
        this.getVideo();
      }
    },

    viewDetail(item) {
      this.showBookBox = false;
      this.$store.commit("setvideoSrc", item.video_url);
      localStorage.setItem("videoSrc", item.video_url);
      this.$router.push({
        path: `/Video/VideoQuestions?id=${item.video_id}&from=video`
      });
    },
    viewVideo(item) {
      console.log(item, "111");
      this.getOneVideo(item.video_id);
      this.like(item.video_id);
    },

    getOneVideo(video_id) {
      VideoHttp.getOneVideo({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        video_id
      }).then(res => {
        console.log(res);
        const { result } = res.data;
        this.videoDetail = Object.assign({}, result.list);
        this.showBookBox = true;
      });
    },

    // 获取 单个图书 喜欢 状态
    like(video_id) {
      VideoHttp.like({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        video_id
      }).then(res => {
        console.log(res);
        this.isLove = res.data.result.list == 0 ? false : true;
      });
    },
    changeLike(video_id) {
      VideoHttp.changeLike({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        video_id,
        is_like: this.isLove ? 1 : 0
      }).then(res => {
        this.like(video_id);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.video-list-cont {
  height: 100%;
  .nav-tabs {
    padding: 0 30px;
  }
  .video-list-cont__box {
    width: 765px;
    margin: 0 auto;
    padding: 0 0 15px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 238px;
      margin-bottom: 15px;
      margin-right: 25px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .img-box {
        height: 230px;
        width: 100%;
        overflow: hidden;
        border-radius: 10px;
        position: relative;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          max-width: 100%;
          max-height: 100%;
        }
      }
      p {
        height: 56px;
        padding: 15px 10px;
        display: flex;
        font-size: 14px;
        align-items: center;
        justify-content: flex-start;
        border-radius: 0 0 10px 10px;
      }
    }
  }

  .video-scroll-box {
    height: calc(100% - 70px);
  }
  @media screen and (max-width: 780px) {
    .video-list-cont__box {
      width: 615px;
      .item {
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(5n) {
          margin-right: 25px;
        }
        p {
          height: 40px;
        }
      }
    }
  }
  @media screen and (min-width: 1350px) {
    .video-list-cont__box {
      width: 1028px;
      .item {
        &:nth-child(3n) {
          margin-right: 25px;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
  @media screen and (min-width: 1500px) {
    .video-list-cont__box {
      width: 1290px;
      .item {
        &:nth-child(4n) {
          margin-right: 25px;
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
}

.video-pop-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  .video-pop-box {
    width: 566px;
    padding: 30px;
    display: flex;
    // height: 358px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    position: relative;
    .video-pop-close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: -35px;
      right: -35px;
      background: url(../../../../assets/images/close.png) center center
        no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
    .book-box-lf {
      margin-right: 15px;
      .img-poster {
        width: 190px;
        height: 190px;
      }
      .title {
        margin-bottom: 10px;
        color: #181818;
        font-size: 18px;
        text-align: center;
      }
    }
    .book-box-rt {
      padding-top: 30px;
      .desc {
        font-size: 12px;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }

      .limit-time {
        margin-top: 20px;
        text-align: right;
        font-size: 12px;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
    }
    .pop-box-btns {
      display: flex;
      padding: 70px 0 20px;
      align-items: center;
      justify-content: center;
      button {
        width: 125px;
        height: 38px;
        margin-right: 10px;
        border-radius: 19px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .love-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        .love-icon {
          width: 16px;
          height: 13px;
          margin-right: 5px;
          background: url("../../../../assets/images/studyCenter/love-icon.png")
            no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>